import AbstractService from '@/services/abstractService'

class ProjectStagesService extends AbstractService {
  endpoint = 'stages'

  index() {
    return this.http.get(this.endpoint)
  }

  put(data) {
    console.log('data', data)
    // define append form
    const formData = new FormData()

    for (const key in data) {
      formData.append(key, data[key])
    }
    return this.http.put(`${this.endpoint}/${data.id}`, formData)
  }
}

const Service = new ProjectStagesService()

export default Service
